
export const MOBILE_APP_CONFIGURATION_ROUTES = {
  BASE: "/",
  LISTS: "/lists/*",
};

export const MOBILE_APP_CONFIGURATION_LINKS = {
  BASE: "/app/fitness",
  LIST: "/app/fitness/lists",
};